import * as types from './types';
import { UserSettingsEnum } from '../helpers/helper';

export const setUserSetting = (store, { key, value }) => {
  return {
    type: types.USER_SETTINGS_SET_USER_SETTINGS,
    payload: { store: store, data: { key, value } },
  };
};

export const setTableStates = data => (dispatch, getState) => {
  dispatch(
    setUserSetting(getState(), {
      key: UserSettingsEnum.REACT_TABLES,
      value: data,
    })
  );
};

export const setPosServingMenusUserSettings = data => (dispatch, getState) => {
  dispatch(
    setUserSetting(getState(), {
      key: UserSettingsEnum.POS_SERVING_MENUS,
      value: data,
    })
  );
};

export const setPosServingOptionsUserSettings = data => (
  dispatch,
  getState
) => {
  dispatch(
    setUserSetting(getState(), {
      key: UserSettingsEnum.POS_SERVING_OPTIONS,
      value: data,
    })
  );
};

export const setMnuEditMenuUserSettings = data => (dispatch, getState) => {
  dispatch(
    setUserSetting(getState(), {
      key: UserSettingsEnum.MNU_EDIT_MENU,
      value: data,
    })
  );
};

export const setLettersUseStudentAddressSetting = (data, formName) => (
  dispatch,
  getState
) => {
  dispatch(
    setUserSetting(getState(), {
      key: UserSettingsEnum.LettersUseStudentAddress + formName,
      value: data,
    })
  );
};



// WEBPACK FOOTER //
// ./src/common/UserSettings/state/actions.js